import React from "react";

import './AppFooter.scss'

import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import AvatarImg from "../AvatarImg";
import {GetUserAvatar} from "../../utils/User";

const AppFooter = ({user}) => {
  return (
    <div className="app-footer border-0 shadow-lg bg-primary-gradiant">
      <Link to="/eventi" className="nav-content-bttn"><i className="feather-calendar"></i></Link>
      <Link to="/impostazioni" className="nav-content-bttn">
        <figure title="Visualizza profilo" className="avatar" style={{marginBottom: "0"}}>
          <AvatarImg src={GetUserAvatar(user)} classes="shadow-sm rounded-circle w35 h35"/>
        </figure>
      </Link>
    </div>
  )
}

AppFooter.propTypes = {
  user: PropTypes.object,
}

export default AppFooter;
